/* eslint-disable unicorn/filename-case */
/* eslint-disable lingui/no-unlocalized-strings */
/* eslint-disable unicorn/filename-case */
import { toast } from "sonner";

export const checkResumePermission = async () => {
  try {
    const response = await fetch("/api/subscription/check-resume", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Resume permission check response:", data);

    const { allowed } = data;

    if (!allowed) {
      toast.error("免费用户仅可创建1份简历，升级会员可创建无限简历");

      setTimeout(() => {
        window.open("/pricing", "_blank")?.focus();
      }, 500);

      return false;
    }

    return true;
  } catch (error) {
    console.error("Resume permission check error:", error);
    toast.error("检查权限失败");
    return false;
  }
};
